import React from "react"
import { Col, Row, Form } from "react-bootstrap"
import { getIn } from "formik"
import FormLabel from "./formLabel"
import * as CommonFunction from "../../common/function"
import NumberFormat from "react-number-format"

function FormDateInputTextbox(props) {
  const { textDesc, form, field, maxLength } = props

  const errorsMsg = getIn(form.errors, field.name)

  const inputErrorClassName = (touched, errors, inputName) => {
    return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px">
          <NumberFormat
            name={field.name}
            placeholder="DD/MM/YYYY"
            className={
              "inputbox " +
              inputErrorClassName(form.touched, form.errors, field.name)
            }
            type="text"
            format={CommonFunction.dateFormat}
            onChange={form.handleChange}
            onBlur={event => {
              form.handleBlur(event)
              // form.setFieldValue(field.name, e.target.value)
            }}
            maxLength={maxLength}
            autoComplete="new-password"
            value={field.value ? field.value : ""}
          />
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormDateInputTextbox
